export const E164_REGEX = /^\+[1-9]\d{6,14}$/;
export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PINCODE_REGEX = /^\d{6}$/;

export const NAME_MAX = 200;
export const CONTACT_PERSON_MAX = 200;
export const ADDRESS_MAX = 255;
export const CITY_MAX = 100;
export const STATE_MAX = 100;
export const NOTES_MAX = 1000;
export const REASON_MAX = 500;

export const PAYMENT_TERMS_OPTIONS = [
  { value: 'IMMEDIATE', label: 'Immediate' },
  { value: 'NET_15', label: 'Net 15 days' },
  { value: 'NET_30', label: 'Net 30 days' },
  { value: 'NET_45', label: 'Net 45 days' },
  { value: 'NET_60', label: 'Net 60 days' },
  { value: 'NET_90', label: 'Net 90 days' },
] as const;

export const PAYMENT_TERMS_LABELS: Record<string, string> = {
  IMMEDIATE: 'Immediate',
  NET_15: 'Net 15',
  NET_30: 'Net 30',
  NET_45: 'Net 45',
  NET_60: 'Net 60',
  NET_90: 'Net 90',
};

export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
] as const;

export const STATE_OPTIONS = [
  { value: '', label: 'Select state' },
  ...INDIAN_STATES.map((s) => ({ value: s, label: s })),
];
